const autoNgTemplateLoaderTemplate1 = require('./time-window-display.html');

import angular from 'angular';
import controller from './time-window-display.controller';

angular.module('portainer.app').component('timeWindowDisplay', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller,
});
